import { IconIntroduction } from '@consta/icons/IconIntroduction'
import { IconTrash } from '@consta/icons/IconTrash'
import type { Props as ButtonProps } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import type { TextFieldProps } from '@consta/uikit/TextField'
import { TextField } from '@consta/uikit/TextField'
import { GroupingHeader } from '@core/components'
import type { KrigingParams, VariogrammType } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import css from '../MapBuildingRightMenu.css'
import type { KrigingAlgorithmMenuProps } from '../types'

const textFieldProps: TextFieldProps<string> = {
  size: 'xs',
  withClearButton: true,
  className: css.algorithmMenuTextFields,
}

const rangFieldProps: TextFieldProps<string> = {
  size: 'xs',
  withClearButton: true,
}

const buttonProps: ButtonProps = {
  size: 'xs',
  view: 'secondary',
  onlyIcon: true,
}

type MethodType = { label: string; key: VariogrammType }

const methodTypeItems: MethodType[] = [{ label: 'Гаусса', key: 'Gaussian' }]

export const KrigingAlgorithmMenu: FC<KrigingAlgorithmMenuProps> = ({
  formData,
  updateKrigingData,
}) => {
  const onVariogrammChange = (value: Nullable<MethodType>) => {
    if (value) {
      updateKrigingData(prev => {
        if (prev) {
          return { ...prev, variogramm: value.key }
        }
      })
    }
  }

  const onParamChange = (key: keyof KrigingParams) => (value: Nullable<string>) => {
    updateKrigingData(prev => {
      if (prev) {
        return { ...prev, [key]: Number(value) }
      }
    })
  }

  return (
    <>
      <GroupingHeader className={css.variogrammHeader} title="Вариограмма">
        <Button className={css.variogrammIntro} iconLeft={IconIntroduction} {...buttonProps} />
        <Button size="xs" view="ghost" iconLeft={IconTrash} onlyIcon={true} />
      </GroupingHeader>

      <div className={css.firstField}>
        <Text className={css.typeText} size="xs" view="secondary">
          Тип
        </Text>
        <Select
          className={css.algorithmMenuTextFields}
          size="xs"
          items={methodTypeItems}
          value={methodTypeItems.filter(item => item.key === formData.kriging?.variogramm)[0]}
          getItemKey={item => item.key}
          getItemLabel={item => item.label}
          onChange={onVariogrammChange}
        />
      </div>
      <div className={css.menuFields}>
        <Text className={css.text} size="xs" view="secondary">
          Общий порог
        </Text>
        <TextField
          type="number"
          className={css.algorithmMenuTextFields}
          size="xs"
          min={0}
          value={formData.kriging ? String(formData.kriging.sill) : undefined}
          withClearButton={true}
          onChange={onParamChange('sill')}
        />
      </div>
      <div className={css.menuFields}>
        <Text className={css.text} size="xs" view="secondary">
          Самородок
        </Text>
        <TextField
          value={formData.kriging ? String(formData.kriging.nugget) : undefined}
          onChange={onParamChange('nugget')}
          {...textFieldProps}
        />
      </div>
      <div className={css.menuFields}>
        <Text className={css.text} size="xs" view="secondary">
          Расстояние
        </Text>
        <TextField
          className={css.algorithmMenuGridFields}
          value={formData.kriging ? String(formData.kriging.minRange) : undefined}
          onChange={onParamChange('minRange')}
          {...rangFieldProps}
        />
        <TextField
          className={css.algorithmMenuGridFields}
          value={formData.kriging ? String(formData.kriging.maxRange) : undefined}
          onChange={onParamChange('maxRange')}
          {...rangFieldProps}
        />
      </div>
      <div className={`${css.menuFields} ${css.angleWrapper}`}>
        <Text className={css.text} size="xs" view="secondary">
          Угол
        </Text>
        <TextField
          value={formData.kriging ? String(formData.kriging.azimuth) : undefined}
          onChange={onParamChange('azimuth')}
          {...textFieldProps}
        />
      </div>
    </>
  )
}
